import Hero from "../../Components/AdminPanel/Hero";
import Panels from "../../Components/AdminPanel/Panels";
import Register from "../../Components/AdminPanel/Register";
// import "../../Styles/Panel/Panel.css";

const AdminPanel = () => {
	return (
		<div className="h-auto  flex flex-col justify-center items-center gap-28 py-10 pb-28 poppins">
			<div className="w-[85%] mt-20 flex flex-col items-center gap-16 px-10 py-20 border-2 border-[#d6d6d6] rounded-xl">
				<Hero />
				<Panels />
				<Register />
			</div>
		</div>
	);
};

export default AdminPanel;
